module.exports = __webpack_public_path__ + "static/media/Closed Captions Test_1630322700692.921bab1b.vtt";